var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M737.5,0h-675C28,0,0,28,0,62.5v675C0,772,28,800,62.5,800h675c34.5,0,62.5-28,62.5-62.5v-675C800,28,772,0,737.5,0z  M288.1,567.3h-78V317.8h78V567.3z M247,286.6h-0.6c-28.3,0-46.6-19.1-46.6-43.3c0-24.7,18.9-43.3,47.7-43.3s46.4,18.6,47,43.3 C294.7,267.3,276.4,286.6,247,286.6z M600,567.3h-88.4V438.3c0-33.8-13.8-56.9-44.2-56.9c-23.3,0-36.2,15.6-42.2,30.6 c-2.2,5.3-1.9,12.8-1.9,20.5v134.8h-87.7c0,0,1.1-228.8,0-249.5h87.7V357c5.2-17.2,33.1-41.6,77.8-41.6c55.5,0,98.9,35.9,98.9,113.1 V567.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinRounded);
export default __webpack_public_path__ + "static/media/linkedin-rounded.aaf394afd9fee18cbc5aeeb7ed826a5d.svg";
export { ForwardRef as ReactComponent };